<template>
 <div>
   <template v-if="table_expiring.items.length">
     <app-cells><h2 class="title">Expiring</h2></app-cells>
     <v-client-table
       :data="table_expiring.items"
       :columns="table_expiring.columns"
       :options="table_expiring.options"
       class="table-default"
     >
       <template #h__number><div class="table-default__left">Number</div></template>
       <template #number="{ row }"><div class="table-default__left">{{ row.number }}</div></template>
       <template #legal_entity="{ row }">{{ row.legal_entity?.name || '-' }}</template>
       <template #group="{ row }">{{ row.group.name }}</template>
       <template #type="{ row }">{{ row.type.name }}</template>
       <template #supplier="{ row }">{{ row.supplier.legal_name }}</template>
       <template #dates="{ row }">
         {{ dateFormat(row.start) }} - {{ dateFormat(row.finish) }}
       </template>
       <template #amount_paid="{ row }">
         {{ row.amount_paid.toLocaleString() }} {{ row.amount_paid_currency.code }}
       </template>
       <template #attachment="{ row }">
         <div class="table-default__controls">
           <button
             @click="onDownloadFile(row.attachment, row)"
             type="button"
           >
             <img src="@/assets/img/download-table-blue-icon.svg" alt="">
           </button>
         </div>
       </template>
     </v-client-table>
   </template>
   <app-cells><h2 class="title">Insurances</h2></app-cells>
   <app-cells>
     <app-button @click.native="onOpenCreateModal(null)">Add insurance</app-button>
     <app-filters
       v-model="status_filter"
       :filters="status_filters"
       name="filterStatus"
       @change="onChangeFilter"
     />
   </app-cells>
   <v-client-table
     :data="table_insurances.items"
     :columns="table_insurances.columns"
     :options="table_insurances.options"
     class="table-default"
   >
     <template #h__number><div class="table-default__left">Number</div></template>
     <template #number="{ row }"><div class="table-default__left">{{ row.number }}</div></template>
     <template #legal_entity="{ row }">{{ row.legal_entity?.name || '-' }}</template>
     <template #group="{ row }">{{ row.group.name }}</template>
     <template #type="{ row }">{{ row.type.name }}</template>
     <template #supplier="{ row }">{{ row.supplier.legal_name }}</template>
     <template #dates="{ row }">
       {{ dateFormat(row.start) }} - {{ dateFormat(row.finish) }}
     </template>
     <template #amount_paid="{ row }">
       {{ row.amount_paid.toLocaleString() }} {{ row.amount_paid_currency.code }}
     </template>
     <template #attachment="{ row }">
       <div class="table-default__controls">
         <button
           @click="onDownloadFile(row.attachment, row)"
           type="button"
         >
           <img src="@/assets/img/download-table-blue-icon.svg" alt="">
         </button>
       </div>
     </template>
     <template #controls="{ row }">
       <div class="table-default__controls">
         <button @click="onOpenCreateModal(row)" type="button"><img src="@/assets/img/edit-table-icon.svg" alt="Edit"></button>
         <button @click="onShowDeleteModal(row)" type="button"><img src="@/assets/img/delete-table-icon.svg" alt="Delete"></button>
       </div>
     </template>
   </v-client-table>
   <app-cells position="between">
     <div>
       <paginate
         :clickHandler="onClickPagination"
         v-if="pagination.pages > 1"
         v-model="pagination.page"
         :page-count="pagination.pages"
         :prev-text="'<'"
         :next-text="'>'"
         :container-class="'pagination'"
         :page-class="'pagination__item'"
         :page-link-class="'pagination__link'"
         :prev-class="'pagination__item pagination__item--prev'"
         :next-class="'pagination__item pagination__item--next'"
         :next-link-class="'pagination__link pagination__link--next'"
         :prev-link-class="'pagination__link pagination__link--prev'"
       />
     </div>
     <app-table-records :all="pagination.count" :count="table_insurances.items.length" :page="pagination.page" />
   </app-cells>
   <modal
     name="create-modal"
     :width="700"
     :height="'auto'"
     :scrollable="true"
     :adaptive="true"
     :clickToClose="false"
     draggable=".popup__title"
     class="modal-not-overflow"
   >
     <div class="popup">
       <button @click="$modal.hide('create-modal')" class="popup__close" type="button"></button>
       <div class="popup__title">{{ insurance_to_action ? 'Update' : 'Add' }} insurance</div>
       <div class="popup__body">
         <form @submit.prevent="onCheckForm">
           <app-grid>
             <template #item-1>
               <app-form-group label="Number" label-for="license_number" required>
                 <app-input
                   @change.native="$v.form.number.$touch()"
                   v-model="form.number"
                   id="license_number"
                   placeholder="Number of license"
                   name="license_number"
                   :error="$v.form.number.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.number.$dirty && !$v.form.number.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Legal entity" required>
                 <app-select
                   v-model="form.legal_entity"
                   :options="legal_entity_options"
                   :clearable="false"
                   :searchable="false"
                   label="short_name"
                   placeholder="Legal entity"
                   :error="$v.form.legal_entity.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.legal_entity.$dirty && !$v.form.legal_entity.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Group" required>
                 <app-select
                   @input="onGroupSelected"
                   v-model="form.group"
                   :options="insurance_groups_options"
                   :clearable="false"
                   placeholder="Group"
                   :error="$v.form.group.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.group.$dirty && !$v.form.group.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Type" required>
                 <app-select
                   v-model="form.type"
                   :options="form.group?.types"
                   :clearable="false"
                   :placeholder="form.group ? 'Type' : 'Please, select a group first'"
                   :readonly="!form.group"
                   :error="$v.form.type.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.type.$dirty && !$v.form.type.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Supplier" required>
                 <app-select
                   @search="onSupplierSearch"
                   v-model="form.supplier"
                   :options="supplier_options"
                   :clearable="false"
                   label="trade_name"
                   placeholder="Supplier"
                   :error="$v.form.supplier.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.supplier.$dirty && !$v.form.supplier.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Insurance value" label-for="insurance_value" required>
                 <app-input
                   @change.native="$v.form.value.$touch()"
                   v-model.number="form.value"
                   id="insurance_value"
                   placeholder="Insurance value"
                   name="insurance_value"
                   type="number"
                   :error="$v.form.value.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.value.$dirty && !$v.form.value.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Currency" required>
                 <app-select
                   v-model="form.value_currency"
                   :options="currency_options"
                   :clearable="false"
                   placeholder="Currency"
                   :error="$v.form.value_currency.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.value_currency.$dirty && !$v.form.value_currency.required">Required field</div>
                 </template>
               </app-form-group>
             </template>
             <template #item-2>
               <app-form-group label="Insurance date" required>
                 <app-date-picker
                   v-model="form.start"
                   placeholder="Date"
                   :error="$v.form.start.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.start.$dirty && !$v.form.start.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Expire date" required>
                 <app-date-picker
                   v-model="form.finish"
                   placeholder="Date"
                   :error="$v.form.finish.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.finish.$dirty && !$v.form.finish.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Amount paid" label-for="amount_paid" required>
                 <app-input
                   @change.native="$v.form.amount_paid.$touch()"
                   v-model.number="form.amount_paid"
                   id="amount_paid"
                   placeholder="0"
                   name="amount_paid"
                   type="number"
                   :error="$v.form.amount_paid.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.amount_paid.$dirty && !$v.form.amount_paid.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Currency" required>
                 <app-select
                   v-model="form.amount_paid_currency"
                   :options="currency_options"
                   :clearable="false"
                   placeholder="Currency"
                   :error="$v.form.amount_paid_currency.$error"
                 />
                 <template #error>
                   <div v-if="$v.form.amount_paid_currency.$dirty && !$v.form.amount_paid_currency.required">Required field</div>
                 </template>
               </app-form-group>
               <app-form-group label="Attachment" required>
                 <app-uploader
                   v-model="form.attachment"
                   :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                   formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
                   class="custom-uploader--flex"
                 />
                 <template #error>
                   <div v-if="$v.form.attachment.$dirty && !$v.form.attachment.required">Required field</div>
                 </template>
               </app-form-group>
             </template>
           </app-grid>
           <app-cells position="center" :indent="false">
             <app-button :disabled="$v.form.$error" type="submit" ref="submit">{{ insurance_to_action ? 'Update' : 'Add' }} insurance</app-button>
           </app-cells>
         </form>
       </div>
     </div>
   </modal>
   <modal
     name="delete"
     :width="400"
     :height="'auto'"
     :scrollable="true"
     :adaptive="true"
     :clickToClose="false"
     class="modal-not-overflow"
     draggable=".popup__title"
     :reset="true"
   >
     <div class="popup">
       <button @click="$modal.hide('delete')" class="popup__close" type="button"></button>
       <div class="popup__title popup__title--flex">
         <img src="@/assets/img/warning-round-icon.svg" alt="">
         Delete insurance
       </div>
       <div class="popup__body">
         <div class="popup__subt">Are you sure you want to delete this insurance?</div>
         <app-cells position="center" :indent="false">
           <app-button @click.native="$modal.hide('delete')" theme="dark">Cancel</app-button>
           <app-button @click.native="onDeleteLicense" ref="deleteEvent">Yes</app-button>
         </app-cells>
       </div>
     </div>
   </modal>
 </div>
</template>

<script>
import {
  deleteCarManagementCarsInsurance,
  getAdministrativeInsuranceGroups,
  getAdministrativeLegalEntities,
  getAdministrativeSuppliers,
  getCarManagementCarsInsurances,
  getCurrencyList,
  patchCarManagementCarsInsurance,
  postCarManagementCarsInsurance,
} from '@/http'
import { format, parseISO } from 'date-fns'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'

export default {
  name: 'CarManagementCarsDetailInsurances',
  data() {
    return {
      table_expiring: {
        items: [],
        columns: ['number', 'legal_entity', 'group', 'type', 'supplier', 'value', 'dates', 'amount_paid', 'attachment'],
        options: {
          headings: {
            number: 'Number',
            legal_entity: 'Legal entity',
            group: 'Group',
            type: 'Type',
            supplier: 'Supplier',
            value: 'Value',
            dates: 'Dates',
            amount_paid: 'Amount paid',
            attachment: 'Attachment',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_insurances: {
        items: [],
        columns: ['number', 'legal_entity', 'group', 'type', 'supplier', 'value', 'dates', 'amount_paid', 'attachment'],
        options: {
          headings: {
            number: 'Number',
            legal_entity: 'Legal entity',
            group: 'Group',
            type: 'Type',
            supplier: 'Supplier',
            value: 'Value',
            dates: 'Dates',
            amount_paid: 'Amount paid',
            attachment: 'Attachment',
            controls: '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      form: {},
      status_filter: '',
      status_filters: [
        { value: '', label: 'All' },
        { value: 'false', label: 'Actual' },
        { value: 'true', label: 'Archive' },
      ],
      supplier_options: [],
      legal_entity_options: [],
      currency_options: [],
      insurance_groups_options: [],
      insurance_to_action: null,
    }
  },
  validations: {
    form: {
      number: { required },
      legal_entity: { required },
      group: { required },
      type: { required },
      supplier: { required },
      value: { required },
      value_currency: { required },
      start: { required },
      finish: { required },
      amount_paid: { required },
      amount_paid_currency: { required },
      attachment: { required },
    }
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    }
  },
  created() {
    this.fetchItemsExpiring()
    this.fetchItemsLicenses()
    getAdministrativeLegalEntities().then(res => { this.legal_entity_options = res.data })
    getAdministrativeInsuranceGroups().then(res => { this.insurance_groups_options = res.data })
    getCurrencyList().then(res => { this.currency_options = res.data })
    if (this.is_general_manager) this.table_insurances.columns.push('controls')
  },
  methods: {
    fetchItemsExpiring() {
      getCarManagementCarsInsurances(Number(this.$route.params.id), { extension_required: true, car: true })
        .then(response => {
          this.table_expiring.items = response.data
        })
    },
    fetchItemsLicenses() {
      getCarManagementCarsInsurances(Number(this.$route.params.id), {
        archive: this.status_filter === 'true' ? true : this.status_filter === '' ? '' : false,
        page: this.pagination.page,
        page_size: 20,
        car: true
      })
        .then(response => {
          this.table_insurances.items = response.data.results
          this.pagination.pages = response.data.pages
          this.pagination.count = response.data.count
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItemsLicenses()
    },
    onChangeFilter() {
      this.pagination.page = 1
      this.fetchItemsLicenses()
    },
    onOpenCreateModal(license) {
      this.insurance_to_action = license
      if (!license) {
        this.form = { type: '' }
      } else {
        this.form = {
          amount_paid: license.amount_paid,
          amount_paid_currency: license.amount_paid_currency,
          value: license.value,
          value_currency: license.value_currency,
          supplier: license.supplier,
          start: license.start,
          finish: license.finish,
          type: license.type,
          group: license.group,
          legal_entity: license.legal_entity,
          number: license.number,
          attachment: license.attachment,
        }
      }
      this.$v.form.$reset()
      this.$modal.show('create-modal')
    },
    onGroupSelected() {
      this.form.type = ''
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (!this.insurance_to_action) {
        postCarManagementCarsInsurance(Number(this.$route.params.id), this.normalizeForm())
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Insurance created',
            })
            this.fetchItemsExpiring()
            this.fetchItemsLicenses()
            this.$modal.hide('create-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      } else {
        patchCarManagementCarsInsurance(Number(this.$route.params.id), this.insurance_to_action.id, this.normalizeForm())
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Insurance updated',
            })
            this.fetchItemsExpiring()
            this.fetchItemsLicenses()
            this.$modal.hide('create-modal')
          })
          .catch(() => {
            this.$refs.submit.preload = false
          })
      }
    },
    normalizeForm() {
      const normalizedForm = { ...this.form }

      normalizedForm.group = normalizedForm.group.id
      normalizedForm.attachment = normalizedForm.attachment.id
      normalizedForm.supplier = normalizedForm.supplier.id
      normalizedForm.legal_entity = normalizedForm.legal_entity.code
      normalizedForm.amount_paid_currency = normalizedForm.amount_paid_currency.code
      normalizedForm.value_currency = normalizedForm.value_currency.code
      normalizedForm.type = normalizedForm.type.id

      return normalizedForm
    },
    onShowDeleteModal(license) {
      this.insurance_to_action = license
      this.$modal.show('delete')
    },
    onDeleteLicense() {
      this.$refs.deleteEvent.preload = true
      deleteCarManagementCarsInsurance(Number(this.$route.params.id), this.insurance_to_action.id)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Insurance deleted',
          })
          this.fetchItemsExpiring()
          this.fetchItemsLicenses()
          this.$modal.hide('delete')
        })
        .catch(() => { this.$refs.deleteEvent.preload = false })
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : ''
    },
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
    onDownloadFile(doc_obj, row) {
      axios.get(doc_obj.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = doc_obj.file_name.split('.').pop()
          const part_of_name = `${row.number} - ${row.legal_entity.name} - ${row.group.name} - ${row.type.name} - ${row.supplier.legal_name}`

          link.href = url
          link.setAttribute('download', `${part_of_name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
  }
}
</script>
